var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "mobile_subject_select",
      staticClass: "offcanvas offcanvas-right",
      attrs: { id: "mobile_subject_select" },
    },
    [
      _c("button", {
        staticStyle: { display: "none" },
        attrs: { id: "mobile_subject_select_toggle" },
      }),
      _c(
        "div",
        {
          staticClass:
            "offcanvas-header d-flex align-items-center justify-content-between pb-5",
        },
        [
          _c("h4", { staticClass: "font-weight-bold m-0" }, [
            _vm._v(" " + _vm._s(_vm.$t("mobileSubjectSelect.title")) + " "),
          ]),
          _c(
            "a",
            {
              attrs: { href: "#", id: "mobile_subject_select_close" },
              on: {
                click: function ($event) {
                  return _vm.closeOffcanvas("mobile_subject_select")
                },
              },
            },
            [_c("i", { staticClass: "ki ki-close icon-md" })]
          ),
        ]
      ),
      _c(
        "perfect-scrollbar",
        {
          staticClass: "offcanvas-content mr-n5 scroll",
          staticStyle: { "max-height": "87vh", position: "relative" },
        },
        [
          _c("div", { staticClass: "bb-input-group search-input" }, [
            _c("i", { staticClass: "fas fa-search" }),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.searchTerm,
                  expression: "searchTerm",
                },
              ],
              attrs: {
                type: "text",
                placeholder: _vm.$t("mobileSubjectSelect.searchPlaceholder"),
              },
              domProps: { value: _vm.searchTerm },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.searchTerm = $event.target.value
                },
              },
            }),
            _c(
              "button",
              {
                staticClass: "bb-badge badge-rounded",
                on: {
                  click: function ($event) {
                    _vm.searchTerm = ""
                  },
                },
              },
              [_c("i", { staticClass: "ki ki-close icon-md" })]
            ),
          ]),
          _c(
            "div",
            { staticClass: "subjects-list" },
            _vm._l(_vm.displaySubjects, function (subject) {
              return _c(
                "div",
                {
                  key: subject.id,
                  staticClass: "subject-item",
                  on: {
                    click: function ($event) {
                      return _vm.selectSubject(subject)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-content-start align-items-center",
                    },
                    [
                      _c("div", { staticClass: "bb-badge" }, [
                        _vm._v(" " + _vm._s(subject.subjectNumber) + " "),
                      ]),
                      _c("div", { staticClass: "subject-details" }, [
                        _c("span", [_vm._v(_vm._s(subject.courtName))]),
                        _c("small", [_vm._v(_vm._s(subject.courtNumber))]),
                      ]),
                    ]
                  ),
                  _c("i", { staticClass: "la la-angle-right" }),
                ]
              )
            }),
            0
          ),
        ]
      ),
      _c("div", { staticClass: "offcanvas-footer" }, [
        _vm.$hasRole(_vm.acl.roles.owner) ||
        _vm.$hasPermission(_vm.acl.permissions.manageAccount)
          ? _c(
              "button",
              {
                staticClass: "new-subject-btn",
                on: { click: _vm.createSubject },
              },
              [_c("i", { staticClass: "la la-plus" })]
            )
          : _vm._e(),
      ]),
      _c("SubjectFormModal", { ref: "subjectFormModal" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }